export function useSystemType(): 'vl-app' | 'vl-admin' {
  return 'vl-app';
}

export default useSystemType;
